module.exports = __webpack_public_path__ + "imgs/default-profile-icon.1d2d83924e60a732d0a5cdbf4d28f7a1.jpg";